import axios from "axios";
import { Environment } from "../lib/environment";
import { registerInterceptors } from "./axios/interceptors";
import { RefreshTokenResponse, RefreshTokenVariables } from "../types";
import { getAppKey, getStoreKey } from "./helpers";
import { appSession } from "../lib/storage";

const apiInstances = {
  gatewayApiInstance: axios.create({
    baseURL: import.meta.env.VITE_GATEWAY_API_URL,
  }),
  insightsApiInstance: axios.create({
    baseURL: import.meta.env.VITE_INSIGHT_API_URL,
  }),
  streamsApiInstance: axios.create({
    baseURL: import.meta.env.VITE_STREAMS_API_URL,
  }),
  lodApiInstance: axios.create({
    baseURL: import.meta.env.VITE_LOD_API_URL,
  }),
};

export const postStaffRefreshToken = (payload: RefreshTokenVariables) => {
  return gatewayApiInstance.post<RefreshTokenVariables, RefreshTokenResponse>(
    "/gateway/staff/refresh_token",
    {
      refresh_token: payload.refreshToken,
      shop_key: payload.storeKey,
      app_key: payload.appKey,
    },
    {
      headers: {
        Authorization: "",
      },
    }
  );
};

export const refreshAccessToken = async (storeKey?: string) => {
  const userData = appSession.getItem();
  const appKey = getAppKey();
  const effectiveStoreKey = getStoreKey(storeKey);

  if (!userData?.refresh_token) {
    throw new Error("Refresh token is not available");
  }

  const response = await postStaffRefreshToken(
    effectiveStoreKey
      ? {
          refreshToken: userData.refresh_token,
          storeKey: effectiveStoreKey,
          appKey,
        }
      : {
          refreshToken: userData.refresh_token,
        }
  );

  appSession.setItem(response.data.result);

  return `Bearer ${response.data.result.access_token.trim()}`;
};

let isLoggingOut = false;

export const logout = () => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  appSession.removeItem();
  window.location.reload();
};

export const updateGlobalAPIBaseURLs = ({ sdp, insight, lod }: Environment) => {
  streamsApiInstance.defaults.baseURL = sdp;
  insightsApiInstance.defaults.baseURL = insight;
  lodApiInstance.defaults.baseURL = lod;
};

registerInterceptors(apiInstances);

export const {
  gatewayApiInstance,
  insightsApiInstance,
  streamsApiInstance,
  lodApiInstance,
} = apiInstances;
